import React from "react";

export const Skeleton = ({ className = "", style }) => (
    <div
        style={style}
        className={`animate-pulse bg-slate-200/70 rounded ${className}`}
    />
);

export const SkeletonText = ({ lines = 3, className = "" }) => (
    <div className={`space-y-2 ${className}`}>
        {Array.from({ length: lines }).map((_, i) => (
            <Skeleton
                key={i}
                className="h-3"
                style={{ width: `${70 + Math.random() * 25}%` }}
            />
        ))}
    </div>
);

export const SkeletonStat = () => (
    <div className="bg-white border border-slate-200 rounded-lg p-6">
        <Skeleton className="h-3 w-20 mb-4" />
        <Skeleton className="h-8 w-16" />
    </div>
);

export const SkeletonStatRow = ({ count = 4 }) => (
    <div className={`grid grid-cols-2 sm:grid-cols-${count} gap-6`}>
        {Array.from({ length: count }).map((_, i) => <SkeletonStat key={i} />)}
    </div>
);

export const SkeletonTableRows = ({ rows = 6, cols = 6 }) => (
    <div className="divide-y divide-slate-100">
        {Array.from({ length: rows }).map((_, r) => (
            <div key={r} className="flex items-center gap-4 px-4 py-3">
                {Array.from({ length: cols }).map((_, c) => (
                    <Skeleton
                        key={c}
                        className="h-3 flex-1"
                        style={{ maxWidth: c === 0 ? "180px" : c === cols - 1 ? "60px" : "auto" }}
                    />
                ))}
            </div>
        ))}
    </div>
);

export default Skeleton;
